import React, { useEffect, useRef, MouseEvent } from "react";

import { Container } from "./styles";

interface Props {
  show?: boolean;
  className?: string;
  parentRef: HTMLElement;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onOutsideClick: (event: MouseEvent<HTMLElement>) => void;
}
const PopoverCard: React.FC<Props> = ({
  show,
  className,
  children,
  parentRef,
  onClick,
  onOutsideClick
}) => {
  const cardRef = useRef<HTMLElement | null>(null);

  function handleElementClick(event) {
    if (
      !parentRef?.contains(event.target) &&
      !cardRef.current?.contains(event.target)
    ) {
      onOutsideClick(event);
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleElementClick);

    return function cleanup() {
      document.removeEventListener("mousedown", handleElementClick);
    };
  }, [onOutsideClick, parentRef]);

  return show ? (
    <Container className={className} ref={cardRef} onClick={onClick}>
      {children}
    </Container>
  ) : null;
};

export default PopoverCard;
